import * as Yup from 'yup';
import { Participant, UserRole, ViewingRequest } from '@models';

export function useValidationSchema() {
  return Yup.object<ViewingRequest>().shape({
    elaborator: Yup.mixed<UserRole>().nullable().required(),
    requester: Yup.mixed<Participant>().nullable().required(),
  });
}
